import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function GastoFormModal({ isOpen, onClose, onSave, initialData }) {
  const [concepto, setConcepto] = useState('');
  const [cantidad, setCantidad] = useState('');
  const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setConcepto(initialData.concepto || '');
        setCantidad(initialData.cantidad || '');
        setFecha(initialData.fecha || new Date().toISOString().split('T')[0]);
      } else {
        setConcepto('');
        setCantidad('');
        setFecha(new Date().toISOString().split('T')[0]);
      }
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const qty = parseFloat(cantidad);
    if (!concepto.trim() || isNaN(qty) || qty <= 0 || !fecha) return;

    onSave({
      id: initialData?.id,
      concepto: concepto.trim(),
      cantidad: qty,
      fecha
    });
  };

  return createPortal(
    <div className="modal-overlay" onClick={(e) => {
      if (e.target.className === 'modal-overlay') onClose();
    }}>
      <div className="modal-content animate-scale" style={{ maxWidth: '450px', width: '100%', margin: 'auto' }}>
        <div className="modal-header">
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
            {initialData ? '✏️ Editar Gasto' : '💰 Nuevo Gasto'}
          </h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="gastoConcepto">Concepto</label>
            <input 
              type="text" 
              id="gastoConcepto"
              value={concepto}
              onChange={(e) => setConcepto(e.target.value)}
              placeholder="Ej. Abono orgánico, manguera, herramientas..."
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="gastoCantidad">Cantidad (€)</label>
            <input 
              type="number" 
              step="0.01"
              min="0.01"
              id="gastoCantidad"
              value={cantidad}
              onChange={(e) => setCantidad(e.target.value)}
              placeholder="0.00"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="gastoFecha">Fecha de Pago</label>
            <input 
              type="date" 
              id="gastoFecha"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
              required
            />
          </div>

          <div style={{ marginTop: '28px', display: 'flex', gap: '12px' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>
              Cancelar
            </button>
            <button 
              type="submit" 
              className="btn" 
              disabled={!concepto.trim() || !cantidad || parseFloat(cantidad) <= 0 || !fecha}
              style={{ flex: 2 }}
            >
              Guardar Gasto
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
